import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Smartphone, Check } from "lucide-react";
import { isSavedOffline, saveOffline } from "@/lib/offline";
import { toast } from "sonner";

export function SaveOfflineButton({ item, size = "default", className = "" }) {
  const [saved, setSaved] = useState(() => isSavedOffline(item.id));
  const save = () => {
    saveOffline(item);
    setSaved(true);
    toast.success("Saved on this phone — open it any time from “On this phone”, even without signal");
  };
  return (
    <Button data-testid="save-offline-btn" onClick={save} size={size} variant="outline" className={`border-stone-300 ${saved ? "text-[#2D6A4F]" : ""} ${className}`}>
      {saved ? <Check className="h-4 w-4 mr-2" /> : <Smartphone className="h-4 w-4 mr-2" />}{saved ? "Saved on phone" : "Save to phone"}
    </Button>
  );
}
